import { useCallback, useEffect, useState } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import api from "@/lib/api";
import { useT52 } from "@/i18n/v52";
import { Empty52, useFmt } from "@/components/v52/Bits";
import { Welcome, WorkAreas, DataOverview, Activity } from "@/components/v52/DashboardParts";
import { OpsAlert } from "@/components/v52/OpsParts";

const get = (url) => api.get(url).then((r) => r.data).catch(() => null);

export default function Dashboard() {
  const { t52 } = useT52();
  const fmt = useFmt();
  const [d, setD] = useState(null);

  const load = useCallback(() => {
    setD(null);
    // A–Z-Master-KPIs nur für Super Admin (403 sonst -> Bereich entfällt, wie bisher).
    Promise.all([get("/dashboard/stats"), get("/dashboard/segments"), get("/az-master/kpis"), get("/az-master/facets")])
      .then(([stats, seg, azm, facets]) => setD({ stats, seg, azm, cantons: facets ? (facets.cantons || []).length : null, at: new Date().toISOString() }));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="f52-page" data-testid="dashboard-page">
      <Welcome />
      <OpsAlert />
      {!d ? (
        <div className="f52-grid-2" data-testid="dashboard-loading" aria-busy="true">
          <span className="f52-sr">{t52("loading")}</span>
          <span className="f52-skel block" /><span className="f52-skel block" />
        </div>
      ) : !d.stats && !d.seg ? (
        <section className="f52-panel">
          <Empty52 icon={AlertTriangle} tone="warn" role="alert" title={t52("loadError")} testid="dashboard-error">
            <button type="button" className="f52-btn f52-btn-primary" onClick={load} data-testid="dashboard-retry"><RefreshCw aria-hidden="true" />{t52("retry")}</button>
          </Empty52>
        </section>
      ) : (
        <>
          <div className="f52-grid-2">
            <WorkAreas stats={d.stats} cust={d.seg?.fundio_customers} />
            <DataOverview seg={d.seg} azm={d.azm} cantons={d.cantons} />
          </div>
          <Activity stats={d.stats} />
          <p className="f52-data-note" data-testid="dashboard-data-note">{t52("dataNote", { time: fmt(d.at) })}</p>
        </>
      )}
    </div>
  );
}
